import { render } from "./CookieBox.vue?vue&type=template&id=158a6326&scoped=true&ts=true"
import script from "./CookieBox.vue?vue&type=script&lang=ts"
export * from "./CookieBox.vue?vue&type=script&lang=ts"

import "./CookieBox.vue?vue&type=style&index=0&id=158a6326&lang=scss&scoped=true"

import exportComponent from "D:\\otimes-en\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158a6326"]])

export default __exports__